import { useState } from "react";
import { ShieldCheck, ChevronDown, ChevronRight, UserCheck, Clock } from "lucide-react";

// İşlem İz Panosu — belge üzerinde "kim yaptı" (personel PIN kimliği) geçmişi.
// transfers/orders belgesindeki history + PIN ile çözülen operator kimliklerini gösterir.
const ACTION_LABELS = {
  requested: "Talep / Sipariş oluşturuldu",
  from_approved: "Gönderen taraf onayladı",
  to_approved: "Alan taraf onayladı",
  approved: "Onaylandı",
  chain_approved: "Zincir onayı verildi",
  rejected: "Reddedildi",
  cancelled: "İptal edildi",
  ordered: "Tedarikçiye gönderildi",
  supplier_notified: "Tedarikçi bilgilendirildi",
  shipped: "Sevk edildi",
  received: "Mal kabul yapıldı",
  correction_requested: "Düzeltme talep edildi",
  correction_resolved: "Düzeltme çözüldü",
};

const fmt = (s) => (s ? String(s).slice(0, 16).replace("T", " ") : "—");

export default function AuditTrailPanel({ detail }) {
  const [open, setOpen] = useState(false);
  if (!detail) return null;
  const hist = Array.isArray(detail.history) ? detail.history : [];

  // Belge seviyesindeki PIN kimlikleri (operator = ortak girişte kendi PIN'iyle işlemi yapan gerçek kişi)
  const identities = [
    { role: "Oluşturan / Talep", name: detail.operator_name, code: detail.operator_staff_code },
    { role: "Sevk eden", name: detail.shipped_operator_name, code: detail.shipped_operator_staff_code },
    { role: "Teslim alan", name: detail.received_operator_name, code: detail.received_operator_staff_code },
  ].filter((x) => x.name);

  const rows = hist.slice().reverse();

  return (
    <div data-testid="audit-trail-panel" className="rounded-xl border border-indigo-200 bg-indigo-50/40">
      <button type="button" data-testid="audit-trail-toggle" onClick={() => setOpen((o) => !o)}
        className="flex w-full items-center justify-between gap-2 px-4 py-2.5 text-left">
        <span className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-wide text-indigo-700">
          <ShieldCheck className="h-4 w-4" /> İşlem İz Panosu — kim yaptı?
        </span>
        <span className="inline-flex items-center gap-1 text-[11px] font-semibold text-indigo-500">
          {rows.length} işlem {open ? <ChevronDown className="h-4 w-4" /> : <ChevronRight className="h-4 w-4" />}
        </span>
      </button>

      {open && (
        <div className="space-y-3 border-t border-indigo-100 px-4 py-3">
          {identities.length > 0 && (
            <div data-testid="audit-identities" className="flex flex-wrap gap-2">
              {identities.map((it, i) => (
                <span key={i} data-testid={`audit-identity-${i}`}
                  className="inline-flex items-center gap-1.5 rounded-full bg-white px-2.5 py-1 text-[11px] font-semibold text-indigo-700 ring-1 ring-inset ring-indigo-200">
                  <UserCheck className="h-3.5 w-3.5" /> {it.role}: <b className="text-slate-800">{it.name}</b>
                  {it.code ? <span className="rounded bg-indigo-100 px-1 font-mono text-[10px] text-indigo-600">{it.code}</span> : null}
                </span>
              ))}
            </div>
          )}

          {rows.length === 0 ? (
            <p data-testid="audit-empty" className="py-2 text-center text-xs text-slate-400">Henüz kayıtlı işlem yok.</p>
          ) : (
            <ol className="space-y-1.5">
              {rows.map((h, i) => (
                <li key={i} data-testid={`audit-row-${i}`}
                  className="flex flex-wrap items-center gap-x-2 gap-y-0.5 rounded-md bg-white px-3 py-2 text-[12px] ring-1 ring-inset ring-slate-100">
                  <span className="font-semibold text-slate-800">{ACTION_LABELS[h.action] || h.action}</span>
                  {h.operator && (
                    <span data-testid={`audit-row-${i}-operator`} className="inline-flex items-center gap-1 rounded-full bg-indigo-100 px-1.5 py-0.5 text-[10px] font-bold text-indigo-700">
                      <UserCheck className="h-3 w-3" /> {h.operator}
                    </span>
                  )}
                  <span className="text-slate-400">·</span>
                  <span className="text-slate-500">hesap: <b className="font-medium text-slate-600">{h.by || "—"}</b></span>
                  <span className="ml-auto inline-flex items-center gap-1 text-[11px] text-slate-400">
                    <Clock className="h-3 w-3" /> {fmt(h.at)}
                  </span>
                  {h.note && <span className="w-full text-[11px] italic text-slate-400">“{h.note}”</span>}
                </li>
              ))}
            </ol>
          )}
        </div>
      )}
    </div>
  );
}
